module.exports = __webpack_public_path__ + "img/img2.3c4d2a19.svg";